import { render } from "./ContractView.vue?vue&type=template&id=210ce20e&scoped=true"
import script from "./ContractView.vue?vue&type=script&lang=js"
export * from "./ContractView.vue?vue&type=script&lang=js"

import "./ContractView.vue?vue&type=style&index=0&id=210ce20e&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210ce20e"]])

export default __exports__